import * as React from "react";
import * as ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ReactModal from "react-modal";

const rootElement: HTMLElement = document.getElementById("root") as HTMLElement;

const root = ReactDOM.createRoot(rootElement);
ReactModal.setAppElement(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
  .then()
  .catch(() => {});
